import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/primeng';
import { environment } from '../../../../../environments/environment';
import { ComponentBase } from '../../../classes/base/component-base';
var DocumentViewerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentViewerComponent, _super);
    function DocumentViewerComponent(ref, config) {
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.config = config;
        _this.listFile = [];
        _this.file = {
            filenName: '',
            path: '',
            type: 1,
            url: ''
        };
        return _this;
    }
    DocumentViewerComponent.prototype.ngOnInit = function () {
        var file = this.config.data;
        var fileType = this.getFileType(file.fileName);
        var documentType = this.getDocumentType(fileType);
        var configsssss = {
            'documentType': "" + documentType,
            'document': {
                'fileType': "" + fileType,
                "key": "" + file.id,
                'title': "" + file.fileName,
                'url': "" + environment.apiDomain.fileEndpoint + file.path
            },
            "editorConfig": {
                "mode": "view",
            }
            // "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.e30.LwimMJA3puF3ioGeS-tfczR3370GXBZMIL-bdpu4hOU"
        };
        var docEditor = new DocsAPI.DocEditor('fileviewer', configsssss);
    };
    DocumentViewerComponent.prototype.onKeydownHandler = function (event) {
        // event.preventDefault();
        if (event.key === 'Escape') {
            this.ref.close(null);
        }
    };
    DocumentViewerComponent.prototype.closePopup = function () {
        this.ref.close(null);
    };
    DocumentViewerComponent.prototype.getFileType = function (fileName) {
        var arr = fileName.split('.');
        return arr[arr.length - 1];
    };
    DocumentViewerComponent.prototype.getDocumentType = function (fileType) {
        if ((/(gif|jpg|jpeg|tiff|png)$/i).test(fileType)) {
            return 'image';
        }
        else if ((/(doc|docm|docx|dot|dotm|dotx|epub|fodt|htm|html|mht|odt|ott|pdf|rtf|txt|djvu|xps)$/i).test(fileType)) {
            return 'text';
        }
        else if ((/(csv|fods|ods|ots|xls|xlsm|xlsx|xlt|xltm|xltx)$/i).test(fileType)) {
            return 'spreadsheet';
        }
        else if ((/(fodp|odp|otp|pot|potm|potx|pps|ppsm|ppsx|ppt|pptm|pptx)$/i).test(fileType)) {
            return 'presentation';
        }
        return '';
    };
    return DocumentViewerComponent;
}(ComponentBase));
export { DocumentViewerComponent };
